import { Box, Button } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { useStyles } from './styles'

interface IFormInfo {
  title: string
  subTitle?: string
  route?: string
}

const FormInfo: React.FC<IFormInfo> = ({ title, subTitle = '', route = null }) => {
  const classes = useStyles()
  const history = useHistory()

  const handleRedirect = () => history.push(route)

  return (
    <Box className={classes.root}>
      <Box className={classes.hero}>
        <span className={classes.title}>{title}</span>
        {subTitle != '' && <span className={classes.subtitle}>{subTitle}</span>}
      </Box>
      {route && (
        <Button type='button' variant='contained' onClick={handleRedirect}>
          Editar
        </Button>
      )}
    </Box>
  )
}

export default FormInfo
